/* RESPONSIBLE TEAM: team-workflows */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class AutomationFinAIAgentAttributesAttributeRoute extends Route {
  reactEnabled() {
    return true;
  }
}

export default ReactRoute(AutomationFinAIAgentAttributesAttributeRoute, {
  overrideRenderTemplate: false,
});
